import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';
import { toastSuccess } from '@components/Toast';

import SupplierDocumentUpload from '@features/supplier/component/SupplierDocumentUpload';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { addBulkSupplierDocument, getSupplierDocuments } from '@services/supplierOnboardingService';

const AddRegulatoryDocuments = ({ onClose, documents }) => {
	const [uploadedData, setUploadedData] = useState({});
	const { id } = useParams();
	const dispatch = useDispatch();

	const onChange = (data, fieldName, type) => {
		setUploadedData({
			...uploadedData,
			[fieldName]: { ...uploadedData[fieldName], [type]: data }
		});
	};

	const handleSubmit = async () => {
		dispatch(openLoader());
		let requestBody = Object.keys(uploadedData)
			.map((key) => {
				const documentDTO = uploadedData[key].documentDTO;
				if (!documentDTO) return null;
				return {
					documentDTOList: [uploadedData[key].documentDTO],
					expiryDate: uploadedData[key].expiryDate || null
				};
			})
			.filter(Boolean);

		await addBulkSupplierDocument(id, requestBody);
		await dispatch(getSupplierDocuments(id));
		toastSuccess('Updated successfully');
		dispatch(closeLoader());
		onClose();
	};

	const renderDocumentUpload = () => {
		return (
			<>
				<SupplierDocumentUpload
					title="Trade License"
					fieldName="tradeLicenseList"
					documents={documents}
					uploadType="REGULATORY_DOCUMENT"
					onChange={onChange}
				/>
				<SupplierDocumentUpload
					title="Factory License"
					fieldName="factoryLicenseList"
					documents={documents}
					uploadType="REGULATORY_DOCUMENT"
					onChange={onChange}
				/>
				<SupplierDocumentUpload
					title="TIN Certificate"
					fieldName="tinCertificateList"
					documents={documents}
					uploadType="REGULATORY_DOCUMENT"
					onChange={onChange}
				/>
			</>
		);
	};

	return (
		<ModalContainer className="supplier-doucment-modal width-430-dialog">
			<div className="common-popup width-430">
				<ModalHeader title="Regulatory Documents" onClose={onClose} />

				<div className="common-popup-body scroll-y-label">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-12">
								<div className="quick-info-files">{renderDocumentUpload()}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddRegulatoryDocuments;
